import { render, staticRenderFns } from "./AirlineEdit.vue?vue&type=template&id=204f5d19"
import script from "./AirlineEdit.vue?vue&type=script&lang=js"
export * from "./AirlineEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports